import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Router } from 'react-router';
import { Provider, connect } from 'react-redux';
import { Layout } from 'antd';
import cn from 'classnames';
import store from './reducers';
import history from './history';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import ru from 'react-intl/locale-data/ru';

import ruTranslation from './translations/ru.json';
import enTranslation from './translations/en.json';

import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import ruRu from 'antd/lib/locale-provider/ru_RU';

import Header from './components/Header';
import Content from './components/Content';
import Sider from './components/Sider';
import PopupWrapper from './components/PopupWrapper';

const localeMap = {
	en: enUS,
	ru: ruRu,
};

let translation = {
	en: enTranslation,
	ru: ruTranslation,
};

const mapStateToProps = ({ user: { locale } }) => {
	return {
		locale
	}
};

const LocaleWrappedProvider = withRouter(connect(mapStateToProps)(({ locale, children }) => {
	console.log(translation, locale);
	return (
		<IntlProvider messages={translation[locale]} locale={locale}>
			<LocaleProvider locale={localeMap[locale]}>
				{children}
			</LocaleProvider>
		</IntlProvider>
	)
}));

function ApplicationWrapper({ children }) {
	return (
		<Provider store={store}>
			<Router history={history}>
				<LocaleWrappedProvider>
					{children}
				</LocaleWrappedProvider>
			</Router>
		</Provider>
	);
}

addLocaleData([...en, ...ru]);

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			overlay: false,
		};
	}
	siderToggled = (d) => {
		const collapsed = (d && d.collapsed) || null;
		if (collapsed == null) {
			this.setState({
				overlay: !this.state.collapsed
			});
		} else {
			this.setState({
				overlay: !collapsed,
			});
		}
	};
	getChildContext = () => {
		return { siderToggled: this.siderToggled };
	};
	onAppClick = () => {
		if (this.state.overlay) {
			this.setState({
				overlay: !this.state.overlay,
			});
		}
	};
	
	render() {
		return (
			<ApplicationWrapper>
				<Layout>
					<Sider collapsed={!this.state.overlay}/>
					<Layout id="App" className={cn('App', this.state.overlay && 'Overlay')}
							onClick={this.onAppClick}>
						<Header />
						<Content />
					</Layout>
					<PopupWrapper/>
				</Layout>
			</ApplicationWrapper>
		);
	}
}

App.childContextTypes = {
	siderToggled: PropTypes.func,
};

export default App;




// WEBPACK FOOTER //
// ./src/App.js